import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Loader, Button, Flex, Tooltip, InfoIcon, Input, Card, CardHeader, Dropdown, CardBody, Pill, Box } from '@fluentui/react-northstar';
import { ExcelColorIcon, ArrowUpIcon } from '@fluentui/react-icons-northstar';
import RevenueService from "../../../services/revenueservice";
import DemoUserFilterDialog from './demoUserFilterDialog';
import '../microsoftbilling/microsoftbilling.scss';
import { OPERATIONSTATUS } from '../../../shared/appcomponents/enums';
import { RenderTooltipCell } from "../../../shared/appcomponents/TooltipWithCopy";
import { Link } from 'react-router-dom';

const PAGE_SIZE = 10;

const HomeDash = (props) => {
  const [dashUrl, setdashUrl] = useState("/dashboards/businessPerformance");
  const [timesheetUrl, settimesheetUrl] = useState("/dashboards/timesheets");
    const { acquireToken, viewStatus } = props;
    const [gridData, setGridData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState({});
    const [skip, setSkip] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [dataState, setDataState] = useState({
        sort: [{ field: "Product", dir: "asc" }],
        take: PAGE_SIZE,
        skip: 0,
    });


    return (
        <>
          <Box className="settings pt-3 pb-1">
            <Flex fill className="error" hAlign="center" vAlign="center">
                <div className="notfound">
                  <div className="notfound-section welcome">
                    <h1>Welcome!</h1>
                    <h2>to Tollring Hub</h2>

                    <style>{`
                      .welcome-instructions {
                        font-weight: 400;
                        font-size: 15px;
                        line-height: 1.6;
                        color: #4a4a4a;
                        max-width: 480px;
                        margin: 12px auto 0;
                        text-align: center;
                      }
                      .welcome-links {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 8px;
                        margin-top: 16px;
                      }
                      .welcome-links p {
                        margin: 0;
                        font-size: 15px;
                        color: #4a4a4a;
                      }
                      .welcome-link {
                        color: #4a4a4a;
                        font-weight: 600;
                        text-decoration: none;
                        border-bottom: 1px solid transparent;
                        transition: border-color 0.15s ease, color 0.15s ease;
                      }
                      .welcome-link:hover,
                      .welcome-link:focus-visible {
                        color: #4a4a4a;
                        border-bottom-color: currentColor;
                      }
                    `}</style>

                    <p className="welcome-instructions">
                      To proceed, select <strong>Dashboard</strong> from the drop-down menu in the
                      top-left corner of Tollring Hub, or:
                    </p>

                    <div className="welcome-links">
                      <p>
                        <Link to={dashUrl} className="welcome-link">Click Here</Link> to open the Business Performance Dashboard.
                      </p>
                      <p>
                        <Link to={timesheetUrl} className="welcome-link">Click Here</Link> to log Timesheets.
                      </p>
                    </div>
                  </div>
                </div>
              </Flex>
          </Box>
        </>
      )
};

export default HomeDash;
